var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.66699 8.0013C6.66699 8.35492 6.80747 8.69406 7.05752 8.94411C7.30757 9.19416 7.6467 9.33464 8.00033 9.33464C8.35395 9.33464 8.69309 9.19416 8.94313 8.94411C9.19318 8.69406 9.33366 8.35492 9.33366 8.0013C9.33366 7.64768 9.19318 7.30854 8.94313 7.05849C8.69309 6.80844 8.35395 6.66797 8.00033 6.66797C7.6467 6.66797 7.30757 6.80844 7.05752 7.05849C6.80747 7.30854 6.66699 7.64768 6.66699 8.0013Z",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F79009"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.73333 11.9573C8.48995 11.9861 8.24507 12.0003 8 12C5.6 12 3.6 10.6667 2 8C3.6 5.33333 5.6 4 8 4C10.4 4 12.4 5.33333 14 8",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F79009"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.6663 10.668L11.333 12.668H13.9997L12.6663 14.668",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F79009"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineOpened);
export default __webpack_public_path__ + "static/media/timeline-opened.d5743a37060a291eca41a32b3184c530.svg";
export { ForwardRef as ReactComponent };